<template v-if="accessDetails">
    <div v-if="staffDetails">
        <div class="row staff-menu-grid" v-if="accessDetails.isSchoolStaff==true">
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="staffDetails.isPortalAdmin == true  || staffDetails.isPrincipal == true">
                <router-link to="/school/academic-management">
                    <div class="card bg-gradient-success">
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i class="fa fa-sliders-h"></i>
                            </div>
                            <h5 class="card-title text-muted mb-0 text-white">Academic Management</h5>
                            <p class="card-description">Configure the academic structure and learning setup.</p>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="staffDetails.isPortalAdmin == true || staffDetails.isRegistrar == true">
                <router-link to="/school/admission">
                    <div class="card bg-gradient-success">
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i class="fa fa-ticket"></i>
                            </div>
                            <h5 class="card-title text-muted text-white mb-0">Admission Management</h5>
                            <p class="card-description">Review applications and manage student admissions.</p>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="staffDetails.isPortalAdmin == true || staffDetails.isClassTeacher == true || staffDetails.isDailyAttendanceManager == true">
                <router-link to="/school/attendance-management">
                    <div class="card bg-gradient-success">
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i class="fa fa-user-clock"></i>
                            </div>
                            <h5 class="card-title text-muted mb-0 text-white">Attendance Management</h5>
                            <p class="card-description">Record and review student attendance.</p>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true">
                <router-link to="/school/career-and-guidance">
                    <div class="card bg-gradient-success">
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i class="fa fa-briefcase"></i>
                            </div>
                            <h5 class="card-title text-muted mb-0 text-white">Career & Guidance</h5>
                            <p class="card-description">Support student guidance and career development.</p>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true">
                <router-link to="/school/certificates">
                    <div class="card bg-gradient-success">
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i class="fa fa-certificate"></i>
                            </div>
                            <h5 class="card-title text-muted mb-0 text-white">Certificates</h5>
                            <p class="card-description">Prepare and manage student certificates.</p>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true">
                <router-link to="/school/communication">
                    <div class="card bg-gradient-success">
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i class="fa fa-comments"></i>
                            </div>
                            <h5 class="card-title text-muted mb-0 text-white">Communication</h5>
                            <p class="card-description">Share updates and keep the school community informed.</p>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true">
                <router-link to="/school/discipline-management">
                    <div class="card bg-gradient-success">
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i class="fa fa-gavel"></i>
                            </div>
                            <h5 class="card-title text-muted mb-0 text-white">Discipline Management</h5>
                            <p class="card-description">Record and follow up on student conduct matters.</p>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true">
                <router-link to="/school/document-management">
                    <div class="card bg-gradient-success">
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i class="fa fa-folder"></i>
                            </div>
                            <h5 class="card-title text-muted mb-0 text-white">Document Management</h5>
                            <p class="card-description">Store and organize important school documents.</p>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true">
                <router-link to="/school/events-management">
                    <div class="card bg-gradient-success">
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i class="fa fa-calendar"></i>
                            </div>
                            <h5 class="card-title text-muted mb-0 text-white">Events Management</h5>
                            <p class="card-description">Plan and coordinate school events and activities.</p>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true || staffDetails.isHOD == true || staffDetails.isClassTeacher == true || staffDetails.isSubjectTeacher == true">
                <router-link to="/school/examination-and-assessment">
                    <div class="card bg-gradient-success">
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i class="fa fa-computer"></i>
                            </div>
                            <h5 class="card-title text-muted mb-0 text-white">Examination & Assessment</h5>
                            <p class="card-description">Set up assessments and review student performance.</p>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true || staffDetails.isBursar == true">
                <router-link to="/school/finance-management">
                    <div class="card bg-gradient-success">
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i class="fa fa-hand-holding-dollar"></i>
                            </div>
                            <h5 class="card-title text-muted mb-0 text-white">Finance Management</h5>
                            <p class="card-description">Oversee school fees, payments, and financial records.</p>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true">
                <router-link to="/school/health-management">
                    <div class="card bg-gradient-success">
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i class="fa fa-question"></i>
                            </div>
                            <h5 class="card-title text-muted mb-0 text-white">Health Management</h5>
                            <p class="card-description">Maintain student health and wellbeing information.</p>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="staffDetails.isPortalAdmin == true || staffDetails.isHostelMaster == true">
                <router-link to="/school/hostel-management">
                    <div class="card bg-gradient-success">
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i class="fa fa-bed"></i>
                            </div>
                            <h5 class="card-title text-muted mb-0 text-white">Hostel Management</h5>
                            <p class="card-description">Manage hostel facilities, rooms, and assignments.</p>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true">
                <router-link to="/school/inventory-and-assets">
                    <div class="card bg-gradient-success">
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i class="fa fa-boxes"></i>
                            </div>
                            <h5 class="card-title text-muted mb-0 text-white">Inventory & Assets</h5>
                            <p class="card-description">Track school equipment, supplies, and other assets.</p>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true || staffDetails.isHOD == true || staffDetails.isClassTeacher == true || staffDetails.isSubjectTeacher == true">
                <router-link to="/school/learning-management">
                    <div class="card bg-gradient-success">
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i class="fa fa-book-reader"></i>
                            </div>
                            <h5 class="card-title text-muted mb-0 text-white">Learning Management</h5>
                            <p class="card-description">Manage lesson resources, plans, and classroom learning.</p>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="staffDetails.isPortalAdmin == true || staffDetails.isLibraryAdmin == true">
                <router-link to="/school/library-management">
                    <div class="card bg-gradient-success">
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i class="fa fa-book"></i>
                            </div>
                            <h5 class="card-title text-muted mb-0 text-white">Library Management</h5>
                            <p class="card-description">Manage library books, lending, and returns.</p>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true || staffDetails.isClassTeacher == true">
                <router-link to="/school/reports-and-analytics">
                    <div class="card bg-gradient-success">
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i class="fa fa-chart-line"></i>
                            </div>
                            <h5 class="card-title text-muted mb-0 text-white">Reports & Analytics</h5>
                            <p class="card-description">Explore school reports, trends, and performance data.</p>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true">
                <router-link to="/school/school-details">
                    <div class="card bg-gradient-success">
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i class="fa fa-school"></i>
                            </div>
                            <h5 class="card-title text-muted mb-0 text-white">School Details</h5>
                            <p class="card-description">Review and update your school's profile details.</p>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true">
                <router-link to="/school/school-website">
                    <div class="card bg-gradient-success">
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i class="fa fa-globe"></i>
                            </div>
                            <h5 class="card-title text-muted mb-0 text-white">School Website CMS</h5>
                            <p class="card-description">Update content and information on the school website.</p>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="staffDetails.isPortalAdmin == true || staffDetails.isRegistrar == true || staffDetails.isPrincipal == true || staffDetails.isHOD == true">
                <router-link to="/school/staff-management">
                    <div class="card bg-gradient-success">
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i class="fa fa-id-card"></i>
                            </div>
                            <h5 class="card-title text-muted mb-0 text-white">Staff Information</h5>
                            <p class="card-description">Manage staff profiles and employment information.</p>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="staffDetails.isPortalAdmin == true || staffDetails.isRegistrar == true || staffDetails.isPrincipal == true || staffDetails.isHOD == true">
                <router-link to="/school/student-information-system">
                    <div class="card bg-gradient-success">
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i class="fa fa-id-card"></i>
                            </div>
                            <h5 class="card-title text-muted mb-0 text-white">Student Information (SIS)</h5>
                            <p class="card-description">Access student profiles, records, and class details.</p>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true">
                <router-link to="/school/subscription">
                    <div class="card bg-gradient-success">
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i class="fa fa-credit-card"></i>
                            </div>
                            <h5 class="card-title text-muted mb-0 text-white">Subscription</h5>
                            <p class="card-description">View and manage your school subscription.</p>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true || staffDetails.isHOD == true">
                <router-link to="/school/timetable-management">
                    <div class="card bg-gradient-success">
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i class="fa fa-calendar"></i>
                            </div>
                            <h5 class="card-title text-muted mb-0 text-white">Timetable Management</h5>
                            <p class="card-description">Organize class schedules and teaching periods.</p>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true">
                <router-link to="/school/transport-management">
                    <div class="card bg-gradient-success">
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i class="fa fa-bus"></i>
                            </div>
                            <h5 class="card-title text-muted mb-0 text-white">Transport Management</h5>
                            <p class="card-description">Coordinate school transport and route information.</p>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            accessDetails: null,
            staffDetails: null,
            onloader: "none",
        };
    },   
    mounted() {
        this.accessDetails = this.$store.getters['auth/_user'];
        this.staffDetails = this.$store.getters['SchoolStaff/_schoolStaff'];
    },
};
</script>
<style scoped>
.staff-menu-grid > .shrink {
    margin: 0 0 1.5rem !important;
    transition: none;
}

.staff-menu-grid > .shrink:hover {
    transform: none;
}

.staff-menu-grid > .shrink > a {
    display: block;
    height: 100%;
    text-decoration: none;
}

.staff-menu-grid .card {
    position: relative;
    height: 100%;
    min-height: 178px;
    margin-bottom: 0;
    overflow: hidden;
    border: 1px solid rgba(37, 51, 65, 0.06);
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.94) !important;
    box-shadow: 0 5px 18px rgba(31, 41, 55, 0.08);
    transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;
}

.staff-menu-grid .card::after {
    position: absolute;
    top: 1.25rem;
    right: 1.25rem;
    color: #98a2b3;
    content: "\2192";
    font-size: 1.5rem;
    line-height: 1;
    transition: color 180ms ease, transform 180ms ease;
}

.staff-menu-grid .shrink > a:hover .card,
.staff-menu-grid .shrink > a:focus-visible .card {
    transform: translateY(-4px);
    border-color: rgba(94, 114, 228, 0.24);
    box-shadow: 0 12px 28px rgba(31, 41, 55, 0.13);
}

.staff-menu-grid .shrink > a:hover .card::after,
.staff-menu-grid .shrink > a:focus-visible .card::after {
    color: #5e72e4;
    transform: translateX(3px);
}

.staff-menu-grid .shrink > a:focus-visible {
    outline: 2px solid #5e72e4;
    outline-offset: 3px;
    border-radius: 14px;
}

.staff-menu-grid .card-body {
    padding: 1.25rem 1.25rem 1.35rem;
}

.staff-menu-grid .icon.icon-shape {
    display: flex;
    width: 3rem;
    height: 3rem;
    align-items: center;
    justify-content: center;
    margin: 0 0 1.1rem !important;
    border: 1px solid rgba(37, 51, 65, 0.06);
    border-radius: 0.85rem !important;
    background: #fff !important;
    box-shadow: 0 3px 7px rgba(31, 41, 55, 0.14) !important;
    color: #5e72e4 !important;
    font-size: 1.15rem;
}

.staff-menu-grid .card-title {
    margin: 0 0 0.35rem;
    color: #344767 !important;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.35;
}

.staff-menu-grid .card-description {
    display: -webkit-box;
    overflow: hidden;
    margin: 0;
    color: #67748e;
    font-size: 0.875rem;
    line-height: 1.45;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}

@media (max-width: 575.98px) {
    .staff-menu-grid .card {
        min-height: 0;
    }
}

@media (prefers-reduced-motion: reduce) {
    .staff-menu-grid .card {
        transition: none;
    }
}
</style>